import { createFileRoute } from "@tanstack/react-router";

import { ChangesPage } from "../../../workspaces/reports/pages/ChangesPage";

export interface ChangesSearch {
  /** The older version; the one before `to` when absent. */
  readonly from?: number;
  /** The newer version; the latest when absent. */
  readonly to?: number;
}

function version(value: unknown): number | undefined {
  const number = typeof value === "number" ? value : typeof value === "string" ? Number(value) : Number.NaN;
  return Number.isInteger(number) && number >= 1 ? number : undefined;
}

/* What changed between two versions of a report, at an address that can be sent. */
export const Route = createFileRoute("/_console/p/$org/$project/reports/$name/changes")({
  validateSearch: (search: Record<string, unknown>): ChangesSearch => ({
    from: version(search.from),
    to: version(search.to),
  }),
  component: ChangesRoute,
});

function ChangesRoute() {
  const { name } = Route.useParams();
  const { from, to } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ChangesPage
      name={name}
      from={from}
      to={to}
      onChoose={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
